import { DEPLOYED_ENV } from '@/environment/environment.constants'
import { EUserCan, Permission } from '../types'

const JOINER = '\n    '

export default function logAccess(permissions: Array<Permission>) {
  if (DEPLOYED_ENV === 'prod') return
  const names = permissions.map(p => EUserCan[p])
  console.log('User permissions:', `${JOINER}${names.join(JOINER)}`)
}